import * as React from 'react';
import { Segment } from '@independent-software/typeui/controls/Segment';

interface IProps {
  title: React.ReactNode;
  children?: React.ReactNode;
  dark?: boolean;
}

const Block = (props: IProps) =>
  <>
    <Segment raised color={props.dark ? '#ddd' : '#eee'} attached="top">
      <b>{props.title}</b>
    </Segment>
    <Segment raised attached="bottom">
      {props.children}
    </Segment>
  </>

export { Block };